import React from 'react'
import { useState } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ApiUrl from '../../../configTools/apiUrl';
import FormInput from '../../forms/formInput';
import Button from '../../forms/blackfillButton';

const ChangepasswordForm = ({Username,Admin}) => {
    const User = JSON.parse(localStorage.getItem("user-info"));
    const [oldpassword,setOldPassword] = useState('');
    const [newpassword,setNewPassword] = useState('');
    const [reenterpassword,setReenterPassword] = useState('');
    const save = ()=>{
      const toastid = toast.loading("Please wait ...",{ position: toast.POSITION.BOTTOM_CENTER});
      if(newpassword === '' || reenterpassword === ''){
        toast.update(toastid, { render: "fields empty", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
        return;
      }
      if(newpassword !== reenterpassword){
        toast.update(toastid, { render: "new password does not match reentered password", type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
        return;
      }
      fetch(ApiUrl.API_URL_Changepassword, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify({
          username: Username,
          password : newpassword,
          oldpassword : oldpassword
        })
      })
      .then(res=>res.json())
      .then(data =>{
        if(data.success){
          ResetFunction();
          setTimeout(() => {
            toast.update(toastid, { render: "Changed", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
        else{
          setTimeout(() => {
            toast.update(toastid, { render: data.responce, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
          }, 500);
        }
      });
    }
  
    const ResetFunction = ()=>{
      setNewPassword('');
      setOldPassword('');
      setReenterPassword('');
    }
  return (
    <>
        <div className='admin_forms_container'>
        {!Admin &&
          <FormInput Lable='Old password' Type='password' Placeholder='Enter old password' Value={oldpassword} setValue={setOldPassword}/>
        }
        <FormInput Lable='New password' Type='password' Placeholder='Enter new password' Value={newpassword} setValue={setNewPassword}/>
        <FormInput Lable='Re-enter password' Type='password' Placeholder='Re-enter new password' Value={reenterpassword} setValue={setReenterPassword}/>
        <Button Value= 'Save' Action={ save } />
        </div>
        <ToastContainer />
    </>
  )
}

export default ChangepasswordForm
